<div class="container">

	<div class="portalCard">

		<div class="rowScreenColPhone">
			<div class="aTitle">
				<mat-icon>event</mat-icon>
				@if( event && event.id ) {
					<span>{{ event.nurIntern ? 'Interne Terminausgabe' : 'Veranstaltungsausgabe' }}</span>
				}
				@else {
					<span>{{ bInternalCreation ? 'Interne Terminerstellung' : 'Veranstaltungserstellung' }}</span>
				}
			</div>
			<mat-spinner diameter=30 [ngStyle]="{ opacity: bCommInProgress ? 1 : 0 }"></mat-spinner>
		</div>

    	<div style="padding:1em; margin: 0em auto 0 auto; position: relative">

		<form *ngIf="selectedForm === 'formG1'" [formGroup]="formG1">

			<div class="mainColumn">

				<div>

					<div
						class="twoFields transitionBackground"
						[ngClass]="{ 'errorBackground': isTmsError() }"
					>

						<triv-input
							[fGroup]="formG1"
							[data]="myInputs.ce_dateStart"
						/>

						<triv-input
							[fGroup]="formG1"
							[data]="myInputs.ce_timeStart"
						/>

					</div>

					<div
						class="twoFields transitionBackground"
						[ngClass]="{ 'errorBackground': isTmsError() }"
					>

						<triv-input
							[fGroup]="formG1"
							[data]="myInputs.ce_dateEnd"
						/>

						<triv-input
							[fGroup]="formG1"
							[data]="myInputs.ce_timeEnd"
						/>
						
					</div>

					<div
						*ngIf="isTmsError()"
						class="errorMessage errorBackground"
					>
						Die Endzeit darf nicht vor der Startzeit liegen.
					</div>

					<div class="twoFields">

						<triv-input
							[fGroup]="formG1"
							[data]="myInputs.ce_dateRegisterUntil"
						/>

						<triv-input
							[fGroup]="formG1"
							[data]="myInputs.ce_timeRegisterUntil"
							style="display: none;"
						/>

					</div>

					<div class="twoFields">

						<triv-input
							[fGroup]="formG1"
							[data]="myInputs.ce_dateReminderMail"
						/>

						<triv-input
							[fGroup]="formG1"
							[data]="myInputs.ce_timeReminderMail"
						/>

					</div>

					<div class="labelLine">Erinnerungsstatus</div>
					<div>
						{{ event.bReminderMailSent ? 'Erinnerung wurde bereits versendet' : 'Erinnerung wurde noch nicht versendet' }}
					</div>

					<triv-input
						[fGroup]="formG1"
						[data]="myInputs.ce_place"
					/>

					<triv-input
						[fGroup]="formG1"
						[data]="myInputs.ce_groups"
					/>

					<triv-input
						[fGroup]="formG1"
						[data]="myInputs.ce_name"
					/>

					<triv-input
						[fGroup]="formG1"
						[data]="myInputs.ce_category"
					/>

				</div>

				<div style="display: flex; flex-flow: column nowrap;">

					<div class="labelLine">Beschreibung</div>

					<ngx-editor-menu
						[editor]="editor"
						[toolbar]="toolbar"
					/>

					<ngx-editor
						[editor]="editor"
						[placeholder]="'Beschreibung'"
						formControlName="ce_description"
						(ngModelChange)="onDescriptionChange($event)"
					/>

				</div>


				<div
					fileDragDrop
					(fileDropped)="trivInputFileUploader.onFileAdd($event)"
					class="dragDropArea"
				>
					<div class="labelLine">Angehängte Dateien</div>

					<div *ngIf="attachedFiles.length">

						<div
							*ngFor="let attachedFile of attachedFiles"
							class="fileLine"
						>
							<div class="fileNameAndDelete">
								<span
									class="fileName"
									(click)="downloadFile(attachedFile)"
								>
									{{attachedFile.file.name}}
								</span>
								<span
									*ngIf="attachedFile.id"
									(click)="deleteFile(attachedFile)"
									class="material-icons deleteBtn"
								>delete</span>
								<span *ngIf="!attachedFile.id && attachedFile.percentageUploaded != 100">
									{{attachedFile.percentageUploaded}}
								%</span>
							</div>

							<mat-progress-bar
								*ngIf="event.id && attachedFile.percentageUploaded && attachedFile.percentageUploaded != 100"
								mode="determinate"
								[value]="attachedFile.percentageUploaded"
							/>

						</div>

					</div>

					<triv-input
						#trivInputFileUploader
						[fGroup]="formG1"
						[data]="myInputs.ce_fileUploader"
						(fileChosen)="aFileWasChosen($event)"
						(filesChosen)="filesWereChosen($event)"
						[bDropInComponentEnabled]="false"
					/>

				</div>

				@if( bAdmin ) {
					<div>
	
						<div class="labelLine">Registrierte Benutzer</div>
	
						@if( !event.assignedUsers.length ) {
							<div class="noElements">Keiner</div>
						}
						@else {

							<div class="sublabelLine">Angemeldet:</div>
		
							<ul>
								@if( !yesUserIds.length ) {
									<li>Keiner</li>
								}
								@for( userId of yesUserIds; track userId ) {
									<li>	
										<div class="subscribedUser">
											<app-avatar-circle [ebeId]="userId" size="xs" class="subscribedUserAvatar"></app-avatar-circle>
			
											<span>{{ mitgliedsnameCache[ userId ] || 'Unbekannt' }}</span>
											<span> - </span>
											<span>{{usernameCache[ userId ]}}</span>
			
											<span
												class="material-icons kickBtn"
												[ngClass]="{ 'disabledBtn' : bCommInProgress }"
												(click)="seeRegistration( userId )"
												title="Anmeldung visualisieren"
											>
												description
											</span>
			
											<span
												class="material-icons kickBtn"
												[ngClass]="{ 'disabledBtn' : bCommInProgress }"
												(click)="clickKickUser( userId )"
												title="Benutzer abmelden"
											>
												logout
											</span>
			
										</div>
									</li>
								}
							</ul>
		
							<div class="sublabelLine">Nicht angemeldet:</div>
		
							<ul>
								@if( !noUserIds.length ) {
									<li>Keiner</li>
								}
								@for( userId of noUserIds; track userId ) {
									<li>	
										<div class="subscribedUser">
											<app-avatar-circle [ebeId]="userId" size="xs" class="subscribedUserAvatar"></app-avatar-circle>
			
											<span>{{ mitgliedsnameCache[ userId ] || 'Unbekannt' }}</span>
											<span> - </span>
											<span>{{usernameCache[ userId ]}}</span>
			
											<span
												class="material-icons kickBtn"
												[ngClass]="{ 'disabledBtn' : bCommInProgress }"
												(click)="seeRegistration( userId )"
												title="Anmeldung visualisieren"
											>
												description
											</span>
			
											<span
												class="material-icons kickBtn"
												[ngClass]="{ 'disabledBtn' : bCommInProgress }"
												(click)="clickKickUser( userId )"
												title="Benutzer abmelden"
											>
												logout
											</span>
			
										</div>
									</li>
								}
							</ul>
						}
	
					</div>
				}

				<div class="download-ics labelLine">
					<span (click)="downloadICSFile()">Download ICS File  </span>
					<mat-icon (click)="downloadICSFile()" id="downloadIcsFileButton">download</mat-icon>
				</div>

				<div *ngIf="!bAdmin">
				</div>

				<div class="btnPanel">

					<last-save-msg
						*ngIf="tmsLastSaveStart"
						[tmsLastSaveStart]="tmsLastSaveStart"
						[tmsLastSaveEnd]="tmsLastSaveEnd"
					/>

					<div class="btnLine">

						<ng-container *ngIf="event.id">

							<ng-container *ngIf="!bRegistered && !bAdmin">

								<button
									*ngIf="isRegistrable()"
									mat-raised-button
									[disabled]="bCommInProgress"
									(click)="subscribeToEvent()"
								>
									<span class="material-icons" style="margin-right: .5em">login</span>
									Anmelden
								</button>

								<button
									*ngIf="!isRegistrable()"
									mat-raised-button
									[disabled]="true"
								>
									Registrierungszeitraum abgelaufen
								</button>

							</ng-container>

							<button
								*ngIf="bRegistered"
								mat-raised-button
								color="warn"
								[disabled]="true"
								style="font-family: 'Passion One'; font-size: x-large;"
							>
								Angemeldet
							</button>

						</ng-container>

						<button
							*ngIf="event.id"
							mat-raised-button
							color="warn"
							type="button"
							(click)="clickDelete()"
							[disabled]="bCommInProgress"
						>
							<span class="material-icons" style="margin-right: .5em">delete</span>
							<span>Löschen</span>
						</button>

						<button
							mat-raised-button
							type="button"
							color="primary"
							(click)="clickPublish()"
							[disabled]="!formG1.valid || bCommInProgress"
						>
							<span class="material-icons" style="margin-right: .5em">cell_tower</span>
							<span>{{ !event.bReleased ? 'Freigeben' : 'Änderungen senden' }}</span>
						</button>

						<button
							mat-raised-button
							color="primary"
							(click)="downloadFormAnswer()"
							[disabled]="!event.assignedUsers.length"
						>
							CSV Export
						</button>

					</div>

					<mat-progress-bar
						mode="indeterminate"
						[ngStyle]="{opacity: bCommInProgress ? 1 : 0}"
						style="position: absolute; bottom: 0; left: 0;"
					/>

				</div>

			</div>

		</form>

		<form *ngIf="selectedForm === 'formG2'" [formGroup]="formG2">

			<div class="mainColumn">

				<div>

					<div class="twoFields transitionBackground" [ngClass]="{ 'errorBackground': isTmsError() }">
						<triv-input [fGroup]="formG2" [data]="myInputs.ce_dateStart"></triv-input>
						<triv-input [fGroup]="formG2" [data]="myInputs.ce_timeStart"></triv-input>
					</div>

					<div class="twoFields transitionBackground" [ngClass]="{ 'errorBackground': isTmsError() }">
						<triv-input [fGroup]="formG2" [data]="myInputs.ce_dateEnd"></triv-input>
						<triv-input [fGroup]="formG2" [data]="myInputs.ce_timeEnd"></triv-input>
					</div>

					<div *ngIf="isTmsError()" class="errorMessage errorBackground">
						Die Endzeit darf nicht vor der Startzeit liegen.
					</div>
					
					<triv-input
						[fGroup]="formG2"
						[data]="getNameInputData()"
						(change)="clickPublish()"
					/>

					<div class="twoFields">
						<triv-input
							[fGroup]="formG2"
							[data]="myInputs.ce_dateReminderMail"
						></triv-input>
						<triv-input
							[fGroup]="formG2"
							[data]="myInputs.ce_timeReminderMail"
						></triv-input>
					</div>

					<div class="labelLine">Erinnerungsstatus</div>
					<div>
						{{ event.bReminderMailSent ? 'Erinnerung wurde bereits versendet' : 'Erinnerung wurde noch nicht versendet' }}
					</div>

				</div>

				<div style="display: flex; flex-flow: column nowrap;">
					<div class="labelLine">Beschreibung</div>
					<ngx-editor-menu [editor]="editor" [toolbar]="toolbar" />
					<ngx-editor
						[editor]="editor"
						[placeholder]="'Beschreibung'"
						formControlName="ce_description"
						(ngModelChange)="onDescriptionChange($event)"
					/>
				</div>

				<div fileDragDrop (fileDropped)="trivInputFileUploader.onFileAdd($event)" class="dragDropArea">
					<div class="labelLine">Angehängte Dateien</div>

					<div *ngIf="attachedFiles.length">
						<div *ngFor="let attachedFile of attachedFiles" class="fileLine">
							<div class="fileNameAndDelete">
								<span class="fileName" (click)="downloadFile(attachedFile)">
									{{attachedFile.file.name}}
								</span>
								<span *ngIf="attachedFile.id" (click)="deleteFile(attachedFile)" class="material-icons deleteBtn">
									delete
								</span>
								<span *ngIf="!attachedFile.id && attachedFile.percentageUploaded != 100">
									{{attachedFile.percentageUploaded}} %
								</span>
							</div>

							<mat-progress-bar
								*ngIf="event.id && attachedFile.percentageUploaded && attachedFile.percentageUploaded != 100"
								mode="determinate"
								[value]="attachedFile.percentageUploaded"
							/>
						</div>
					</div>

					<triv-input
						#trivInputFileUploader
						[fGroup]="formG2"
						[data]="myInputs.ce_fileUploader"
						(fileChosen)="aFileWasChosen($event)"
						(filesChosen)="filesWereChosen($event)"
						[bDropInComponentEnabled]="false"
					></triv-input>
				</div>

				<div class="download-ics labelLine">
					<span (click)="downloadICSFile()">Download ICS File </span>
					<mat-icon (click)="downloadICSFile()" id="downloadIcsFileButton">download</mat-icon>
				</div>

				<div *ngIf="event?.id" class="btnPanel">
					<last-save-msg
						*ngIf="tmsLastSaveStart"
						[tmsLastSaveStart]="tmsLastSaveStart"
						[tmsLastSaveEnd]="tmsLastSaveEnd"
					></last-save-msg>

					<div class="btnLine">
						<ng-container *ngIf="event.id">
							<ng-container *ngIf="!bRegistered && !bAdmin">
								<button
									*ngIf="isRegistrable()"
									mat-raised-button
									[disabled]="bCommInProgress"
									(click)="subscribeToEvent()"
								>
									<span class="material-icons" style="margin-right: .5em">login</span>
									Anmelden
								</button>
								<button *ngIf="!isRegistrable()" mat-raised-button [disabled]="true">
									Registrierungszeitraum abgelaufen
								</button>
							</ng-container>

							<button *ngIf="bRegistered" mat-raised-button color="warn" [disabled]="true" style="font-family: 'Passion One'; font-size: x-large;">
								Angemeldet
							</button>
						</ng-container>

						<button
							*ngIf="event.id"
							mat-raised-button
							color="warn"
							type="button"
							(click)="clickDelete()"
							[disabled]="bCommInProgress"
						>
							<span class="material-icons" style="margin-right: .5em">delete</span>
							<span>Löschen</span>
						</button>
					</div>

					<mat-progress-bar
						mode="indeterminate"
						[ngStyle]="{opacity: bCommInProgress ? 1 : 0}"
						style="position: absolute; bottom: 0; left: 0;"
					/>
					
				</div>
			</div>

		</form>

	</div>

</div>

